module.exports = __webpack_public_path__ + "img/outlined_basketball.cc56c425.svg";